module.exports = __webpack_public_path__ + "static/img/active4.4684bd79.png";